import DcPage from '@/components/landing/dcv2/DcPage';
import { SubforumList } from '@/features/forum/components/SubforumList';
import { ForumProvider } from '@/features/forum/ForumContext';

export default function Forum() {
  return (
    <ForumProvider>
      <DcPage>
        <SubforumList />
      </DcPage>
    </ForumProvider>
  );
}











